module.exports = "https://web-assets.ifttt.com/packs/media/shared/applet-card-archived-icon-23aeec52.svg";